import { get } from './client';
import type {
  AdminTransactionListResponse,
  AdminTransactionDetail,
  ListAdminTransactionsParams,
} from '@/types/admin-transaction';

export async function listAdminTransactions(
  params?: ListAdminTransactionsParams
): Promise<AdminTransactionListResponse> {
  const queryParams: Record<string, string> = {};
  if (params?.merchantId) queryParams.merchantId = params.merchantId;
  if (params?.serviceId) queryParams.serviceId = params.serviceId;
  if (params?.status) queryParams.transactionStatus = params.status;
  if (params?.limit) queryParams.limit = String(params.limit);
  if (params?.cursor) queryParams.cursor = params.cursor;
  return get<AdminTransactionListResponse>('/admin/transactions', queryParams);
}

/**
 * Get a single transaction by ID.
 * Spec 0027: Optional merchantId hint for platform_admin routing via Facade.
 */
export async function getAdminTransaction(
  transactionId: string,
  merchantId?: string,
): Promise<AdminTransactionDetail> {
  const params: Record<string, string> = {};
  if (merchantId) params.merchantId = merchantId;
  return get<AdminTransactionDetail>(`/admin/transactions/${encodeURIComponent(transactionId)}`, params);
}
